import styled from "@emotion/styled";
import { Colors } from "theme/colors";
import { fontQuicksand } from "theme/fonts";

export const StyledLine = styled.div`
  margin-top: 2rem;
  margin-bottom: 2rem;
  height: 1rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

export const StyledActualLine = styled.div`
  border-top: 1px solid ${Colors.MID_GRAY};
  flex: 1;
  height: 0;
`;

export const StyledText = styled.div`
  padding-left: 1rem;
  padding-right: 1rem;
  color: ${Colors.DARK_GRAY};
  ${fontQuicksand()};
`;
